import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/catering/catering-1.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/catering/catering-10.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/catering/catering-2.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/catering/catering-3.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/catering/catering-4.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/catering/catering-6.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/catering/catering-7.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/catering/catering-9.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/blur-fade.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/app/src/components/ui/separator.tsx");
